import axios from "../../../axiosClient";

export const getDaylightProfileList = async (
  assetCode: string,
  signal?: any,
) => {
  const res = await axios.get(
    `/slpapp/DaylightProfile/GetDaylightProfile`,
    { params: { assetCode }, signal }
  );
  return res?.data;
};

export const getDaylightProfile = async (
  pageSize: any,
  PageNumber: any,
  SortBy: any,
  SortDirection: any,
  id: any,
  searchText: any = ""
) => {
  const body = {
    pageSize,
    PageNumber,
    SortBy,
    SortDirection,
    searchText,
  };
  const res = await axios.get(`/slpapp/DaylightProfile/GetDaylightProfile`, {
    params: { assetCode: id, ...body },
  });

  return res?.data?.data;
};

export const saveDaylightProfile = async (payload: any) => {
  const res = await axios.post(
    `/slpapp/DaylightProfile/SetDaylightProfile`,
    payload
  );
  return res?.data;
};

export const sendDaylightProfileCommand = async (assetCode: string, signal?: any) => {
  const res = await axios.post(
    `/slpapp/GetCommand/SendCommandToGetDaylightProfileConfiguration`,
    undefined,
    { params: { assetCode }, signal }
  );
  return res?.data;
};

export const getDaylightProfileHistory = async (query: any) => {
  const {
    assetCode,
    ackstatus,
    status,
    pageNumber = 1,
    pageSize = 10,
    sortBy = "SentOn",
    sortDirection = "DESC",
    searchText,
  } = query;
  const res = await axios.post(
    `/slpapp/DaylightProfile/GetProfileCommandHistory`,
    {
      pageNumber,
      searchText: searchText || "",
      sortBy,
      sortDirection,
      pageSize,
    },
    {
      params: {
        assetCode,
        profileTypeId: 2,
        status: status ?? ackstatus ?? "All",
      },
    }
  );
  return res?.data;
};

export const getDaylightProfileHistoryDetail = async (historyId: number, signal?: any) => {
  const res = await axios.post(
    `/slpapp/DaylightProfile/GetProfileCommandHistoryDetail`,
    undefined,
    { params: { historyId }, signal }
  );
  return res?.data;
};

export const getDaylightProfileBackupRestore = async (assetCode: string, signal?: any) => {
  const res = await axios.get(
    `/slpapp/DaylightProfile/GetDaylightProfileBackupRestore`,
    { params: { assetCode }, signal }
  );
  return res?.data;
};

export const getDaylightProfileGetHistoryAndBaseline = async (assetCode: string, signal?: any) => {
  const res = await axios.get(
    `/slpapp/DaylightProfile/GetDaylightProfileGetHistoryAndBaseline`,
    { params: { assetCode }, signal }
  );
  return res?.data;
};

export const restoreDaylightProfile = async (payload: any) => {
  const res = await axios.post(
    `/slpapp/DaylightProfile/RestoreDaylightProfile`,
    payload
  );
  return res?.data;
};

export const applyBaselineAsDaylightProfile = async (payload: any, signal?: any) => {
  const res = await axios.post(
    `/slpapp/DaylightProfile/ApplyBaselineAsDaylightProfile`,
    payload,
    { signal }
  );
  return res?.data;
};

export const setDaylightProfileBaseline = async (payload: any, signal?: any) => {
  const res = await axios.post(
    `/slpapp/DaylightProfile/SetDaylightProfileBaselineConfigurations`,
    payload,
    { signal }
  );
  return res?.data;
};

export const enableOrDisableDaylightProfile = async (id: string | number, isEnable: boolean, signal?: any) => {
  const res = await axios.post(
    `/slpapp/DaylightProfile/UpdateDaylightProfile`,
    {},
    { params: { id, isEnable }, signal }
  );
  return res?.data;
};

export const getGatewayZone = async (
  gatewayCode: string,
  PageNumber: any = 0,
  pageSize: any = 0,
) => {
  if (!gatewayCode) return;
  const res = await axios.get(`/slpapp/GatewayZone`, {
    params: { gatewayCode, PageNumber, pageSize },
  });

  return res?.data;
};
